import Velocity from "velocity-animate";

$(function () {
    $('.js-scroll-to').on('click', function(ev) {
        ev.preventDefault();
        const $target = $(ev.currentTarget.hash);
        if (!$target) return;
        const offset = $('.js-header').outerHeight() + 10;
        Velocity($target, 'scroll', {offset: -offset});
    });
});



//////////////////
// WEBPACK FOOTER
// ./assets/js/scrollTo.js
// module id = 9
// module chunks = 0